<template>
  <div class="zj-login-page">
    <zj-startup :percent="startup.percent" :msg="startup.msg" />
  </div>
</template>

<script>
import utils from "../utils";
import { setToken,setSessionStorage } from "@/utils/auth";
import { ssoLogin } from "../api/system/permission/login";

export default {
  name: "ZjNoLoginNew",
  data() {
    return {
      startup: {
        percent: 0,
        msg: "启动中...",
      },
      isIgnoreLogin: false,
      interval: 0, //加载的定时器
      timeStop: 0, //加载成功停止的定时器
    };
  },
  created() {
    this.login();
  },
  methods: {
    // 登录
    login() {
      this.isIgnoreLogin = true;
      let accessToken = decodeURIComponent(this.getQueryString("accessToken"));
      console.log("accessToken++++++nologin")
      console.log(accessToken)
      let param = {
        accessToken,
      };
      setToken(accessToken);
      setSessionStorage("accessToken",accessToken);
      // setSessionStorage("accessToken2222",accessToken);
      this.$store.commit("SET_TOKEN", accessToken);
      this.ssoPermissionsApi(param);
    },

    // 登录成功
    onLogin(user) {
      this.startup.percent = 100;
      this.user.setUser(user);
      localStorage.setItem("isIgnoreLogin", false);
      this.$emit("login", user);
      this.logInfo.ActionName = "登录";
      this.logInfo.LogMessage = "登录成功";
      this.logInfo.ModuleName = "登录";
      this.logInfo.PageName = "登录";
      this.addOperationLog();
    },
    ssoPermissionsApi(param) {
      let that = this;
      let endPro = 95;
      that.interval = setInterval(function () {
        if (that.startup.percent < endPro) {
          that.startup.percent++;
        }
      }, 500);
      ssoLogin(param)
        .then((res) => {
          if (res.code == 200) {
            let user = {};
            user.UserName = res.data.user.userName || "";
            user.UserId = res.data.user.userId || "";
            user.LoginName = res.data.user.userName || "";
            user.userInfo = res.data || {};
            sessionStorage.setItem("accessToken", res.data.accessToken)
            this.onLogin(user);
          } else {
            this.startup.percent = 0;
            this.startup.msg = "启动失败";
            console.log(res.msg);
          }
        })
        .catch((e) => {
          console.error(e);
          this.startup.percent = 0;
          this.startup.msg = "服务异常，请联系管理员！";
        });
    },
    getQueryString(name) {
      const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      const r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return decodeURI(r[2]);
      }
    },
  },
};
</script>
